import React, { useContext } from 'react';
const TextContext = React.createContext('body');
export function useTextValue() {
  return useContext(TextContext);
}
export function TextProvider(_ref) {
  let {
    children,
    value
  } = _ref;
  return React.createElement(TextContext.Provider, {
    value: value
  }, children);
}